import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { createMarkup } from '../utils';
import { TooltipInfo } from './icon/icons/TooltipInfo';
import { Panel } from './Panel';

export interface AlertProps {
  heading?: string;
  text?: string;
}

const StyledAlert = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    gap: ${space.md};
  `};
`;

export const Alert: FC<AlertProps> = ({ heading, text, ...rest }) => (
  <Panel heading={heading} backgroundColor="grey1" {...rest}>
    <StyledAlert>
      <TooltipInfo color="accent3" size="default" />
      {createMarkup(text)}
    </StyledAlert>
  </Panel>
);
